import { useSearchParams } from 'react-router'

export default function useEmbedded() {
  const [searchParams] = useSearchParams()
  return searchParams.get('embedded') === 'true'
}
